__turbopack_context__.v({
  "section": "GNKNxq_section",
});
